import { FormMap } from "./FormMap";
import React from "react";

type BlockProp = {
  block: any;
  index: number;
};

const ConsentBlock: React.FC<BlockProp> = ({ block }) => {
  const Component = FormMap[block.type];

  return (
    <>
      {Component && (
        <div className={"consent-block"}>
          {Component && <Component currentBlock={block} />}
        </div>
      )}
    </>
  );
};

export default React.memo(ConsentBlock);
